module.exports = __webpack_public_path__ + "img/home.8a81144e.svg";